import {
    VRCORE_GET_JOB_PACKS,
    VRCORE_JOB_PACK_PROFILE_SELECTED_INDEX,
    VRCORE_PROFILE_EDIT_SELECTED_TAB,
    VRCORE_POST_EDITED_USER,
    VRCORE_REMOVE_JOB_PACK,
    VRCORE_GET_TEMPLATES,
    GET_REPORT_TITLES,
    VRCORE_GET_ALL_USERS,
    VRCORE_UPLOAD_FILE,
    VRCORE_REMOVE_FILE,
    VRCORE_SET_FILES
} from "./types";
import firebase from "firebase/app";
export const uploadFile = (job_pack, file, callback) => {
    return dispatch => {
        dispatch({
            type: VRCORE_UPLOAD_FILE.REQUEST
        });
        try {
            let task = firebase
                .storage()
                .ref(`files/${job_pack.job_name}/`)
                .child(file.name)
                .put(file);
            task.on(
                "state_changed",
                function(snapshot) {
                    // Observe state change events such as progress, pause, and resume
                    // Get task progress, including the number of bytes uploaded and the total number of bytes to be uploaded

                    let progress = (snapshot.bytesTransferred / snapshot.totalBytes) * 100;

                    callback({
                        inProgress: true,
                        finished: false,
                        error: false,
                        progress: progress,
                        msg: "Upload is " + progress + "% done"
                    });
                },
                error => {
                    // Handle unsuccessful uploads
                    callback({
                        inProgress: false,
                        finished: false,
                        error: true,
                        msg: "Something went wrong with this upload!"
                    });
                },
                () => {
                    // Handle successful uploads on complete
                    // For instance, get the download URL: https://firebasestorage.googleapis.com/...
                    task.snapshot.ref.getDownloadURL().then(function(url) {
                        let files = {
                            file: file.name,
                            fileURL: url
                        };
                        if (typeof job_pack["attached_files"] === "undefined")
                            job_pack["attached_files"] = [files];
                        else job_pack["attached_files"] = [...job_pack["attached_files"], files];

                        firebase
                            .database()
                            .ref(`/subjects/job_packs/${job_pack.job_id}/profile`)
                            .set(job_pack, snapshot => {
                                dispatch({
                                    type: VRCORE_UPLOAD_FILE.SUCCESS,
                                    payload: file
                                });
                                callback({
                                    inProgress: false,
                                    finished: true,
                                    error: false,
                                    msg: "File Successfully Uploaded!"
                                });
                            });
                    });
                }
            );
        } catch (e) {
            dispatch({
                type: VRCORE_UPLOAD_FILE.FAIL
            });
        }
    };
};
export const removeFile = (job, filename, i) => {
    return dispatch => {
        dispatch({
            type: VRCORE_REMOVE_FILE.REQUEST
        });

        try {
            const files = job["attached_files"];
            if (typeof files !== "undefined") files.splice(i, 1);
            firebase
                .storage()
                .ref(`files/${job.job_name}/`)
                .child(filename)
                .delete()
                .then(function() {
                    firebase
                        .database()
                        .ref(`/subjects/job_packs/${job.job_id}/profile`)
                        .set(job, snapshot => {
                            dispatch({
                                type: VRCORE_REMOVE_FILE.SUCCESS,
                                payload: job["attached_files"]
                            });
                        });

                    // File deleted successfully
                })
                .catch(function(error) {
                    // Uh-oh, an error occurred!
                });
        } catch (e) {
            dispatch({
                type: VRCORE_REMOVE_FILE.FAIL
            });
        }
    };
};
export const setUploadedFiles = files => {
    return dispatch => {
        dispatch({
            type: VRCORE_SET_FILES.REQUEST
        });

        try {
            if (typeof files === "undefined") files = [];
            dispatch({
                type: VRCORE_SET_FILES.SUCCESS,
                payload: files
            });
        } catch (e) {
            dispatch({
                type: VRCORE_SET_FILES.FAIL
            });
        }
    };
};
export const getJobPack = id => {
    return dispatch => {
        dispatch({
            type: VRCORE_GET_JOB_PACKS.REQUEST
        });

        try {
            firebase.auth().onAuthStateChanged(user => {
                if (user === null) {
                    dispatch({
                        type: VRCORE_GET_JOB_PACKS.FAIL
                    });
                } else {
                    firebase
                        .database()
                        .ref("/subjects/job_packs/" + id)
                        .on("value", snapshot => {
                            dispatch({
                                type: VRCORE_GET_JOB_PACKS.SUCCESS,
                                payload: snapshot.val()
                            });
                        });
                }
            });
        } catch (e) {
            dispatch({
                type: VRCORE_GET_JOB_PACKS.FAIL
            });
        }
    };
};
export const getReportTitles = () => {
    return dispatch => {
        dispatch({
            type: GET_REPORT_TITLES.REQUEST
        });
        try {
            firebase.auth().onAuthStateChanged(user => {
                if (user === null) {
                    dispatch({
                        type: GET_REPORT_TITLES.FAIL
                    });
                } else {
                    firebase
                        .database()
                        .ref("collections/report_titles")
                        .on("value", snapshot => {
                            dispatch({
                                type: GET_REPORT_TITLES.SUCCESS,
                                payload: snapshot.val()
                            });
                        });
                }
            });
        } catch (e) {
            dispatch({
                type: GET_REPORT_TITLES.FAIL
            });
        }
    };
};
export const removeJobPack = job => {
    return dispatch => {
        dispatch({ type: VRCORE_REMOVE_JOB_PACK.REQUEST });
        job.deleted = true;
        try {
            firebase.auth().onAuthStateChanged(user => {
                if (user === null) {
                    dispatch({ type: VRCORE_REMOVE_JOB_PACK.FAIL });
                } else {
                    firebase
                        .database()
                        .ref(`/subjects/job_packs/${job.job_id}/profile`)
                        .set(job);
                }
            });
        } catch (e) {
            dispatch({ type: VRCORE_REMOVE_JOB_PACK.FAIL });
        }
    };
};
export const setSelectedJobPackIndex = index => {
    return dispatch => {
        dispatch({
            type: VRCORE_JOB_PACK_PROFILE_SELECTED_INDEX,
            payload: index
        });
    };
};
export const setSelectedTab = index => {
    return dispatch => {
        dispatch({
            type: VRCORE_PROFILE_EDIT_SELECTED_TAB,
            payload: index
        });
    };
};

export const postEditedJobPack = (job_pack, uuid) => {
    return dispatch => {
        dispatch({
            type: VRCORE_POST_EDITED_USER.REQUEST
        });

        try {
            firebase.auth().onAuthStateChanged(user => {
                if (user === null) {
                    dispatch({
                        type: VRCORE_POST_EDITED_USER.FAIL
                    });
                } else {
                    firebase
                        .database()
                        .ref(`/subjects/job_packs/${uuid}/profile`)
                        .set(job_pack, snapshot => {
                            dispatch({ type: VRCORE_POST_EDITED_USER.SUCCESS });
                        });
                }
            });
        } catch (e) {
            dispatch({
                type: VRCORE_POST_EDITED_USER.FAIL
            });
        }
    };
};
export const getTemplates = () => {
    return dispatch => {
        dispatch({ type: VRCORE_GET_TEMPLATES.REQUEST });

        try {
            firebase.auth().onAuthStateChanged(user => {
                if (user === null) {
                    dispatch({ type: VRCORE_GET_TEMPLATES.FAIL });
                } else {
                    firebase
                        .database()
                        .ref("/subjects/job_templates")
                        .on("value", snapshot => {
                            dispatch({
                                type: VRCORE_GET_TEMPLATES.SUCCESS,
                                payload: snapshot.val()
                            });
                        });
                }
            });
        } catch (e) {
            dispatch({ type: VRCORE_GET_TEMPLATES.FAIL });
        }
    };
};
export const getAllUsers = () => {
    return dispatch => {
        dispatch({
            type: VRCORE_GET_ALL_USERS.REQUEST
        });
        try {
            firebase.auth().onAuthStateChanged(user => {
                if (user === null) {
                    dispatch({
                        type: VRCORE_GET_ALL_USERS.FAIL
                    });
                } else {
                    firebase
                        .database()
                        .ref("users")
                        .on("value", snapshot => {
                            dispatch({
                                type: VRCORE_GET_ALL_USERS.SUCCESS,
                                payload: snapshot.val()
                            });
                        });
                }
            });
        } catch (e) {
            dispatch({
                type: VRCORE_GET_ALL_USERS.FAIL
            });
        }
    };
};
